<template>
  <div class="column is-one-third has-text-centered">
    <div class="card">
      <div :class="'logo-height ' + bg"><img
        class="logo"
        :src="'/img/logos/' + fileName + '.png'"
        :alt="fileName.replace(/-/g, ' ')"
        :title="fileName.replace(/-/g, ' ')"
        width="275"
      >
      </div>
      <div class="card-content">
        <p><strong>{{ fileName.replace(/-/g, ' ') }}</strong></p>
      </div>
      <footer class="card-footer">
        <a class="card-footer-item" :href="'/img/logos/' + fileName + '.ai'" title="Download .ai Version" target="_blank" download>.ai</a>
        <a class="card-footer-item" :href="'/img/logos/' + fileName + '.eps'" title="Download .eps Version" target="_blank" download>.eps</a>
        <a class="card-footer-item" :href="'/img/logos/' + fileName + '.svg'" title="Download .svg Version" target="_blank" download>.svg</a>
        <a class="card-footer-item" :href="'/img/logos/' + fileName + '.png'" title="Download .png Version" target="_blank" download>.png</a>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bg: String,
    fileName: String
  }
}
</script>
